<template>
    <!-- <Header placeholder /> -->
    <div style="background-color: #f5f5f5;">
	    <Poster
		    :posters="carousel"
	    />
	    
	    <div class="wow animate__fadeIn" data-wow-duration="1s">
		    <Profile
			    :company-info="companyInfo"
		    />
	    </div>
	    
	    <Video :video-resource="videoResource" />
	    
	    <CustomerCase
	      :customer-case="customerCase"
	    />
	    
	    <div class="wow animate__fadeIn" data-wow-duration="1s">
		    <Product />
	    </div>
	    
	    <div class="wow animate__fadeIn" data-wow-duration="1s">
		    <Honor
			    :honors="honors"
			    :company-info="companyInfo"
		    />
	    </div>
	    
	    <div class="wow animate__fadeIn" data-wow-duration="2s">
		    <News
			    :news="news"
		    />
	    </div>
	    
	    <div class="wow animate__zoomIn" data-wow-duration="1s">
		    <Customer
			    :customer="customer"
		    />
	    </div>
	    
	    <div class="wow animate__fadeIn" data-wow-duration="1s">
		    <CompanyCulture
		      :company-culture="companyCulture"
		    />
	    </div>
	    
	    <Slogan />
    </div>
    
</template>

<script setup>
import { onMounted, computed, ref } from 'vue'
import { useStore } from "vuex";
import axios from "axios";
import Poster from './Poster';
import Profile from './components/Profile.vue';
import Video from "@/pages/Index/components/Video.vue";
import Product from "@/pages/Index/components/Product.vue";
import News from "@/pages/Index/components/News.vue";
import Customer from "@/pages/Index/components/Customer.vue";
import CompanyCulture from "@/pages/Index/components/CompanyCulture.vue";
import Slogan from "@/pages/Index/components/Slogan.vue";
import CustomerCase from "@/pages/Index/components/CustomerCase.vue";
import Honor from "@/pages/Index/components/Honor.vue";

const store = useStore()

const homeInfo = ref(null)
const customerCase = ref([])

const currentLang = computed(() => store.getters.currentLanguage)

const companyInfo = computed(() => store.state.companyInfo)

const carousel = computed(() => companyInfo.value?.carousel_chart)

const news = computed(() => homeInfo.value?.new)

const customer = computed(() => homeInfo.value?.enterprises)

const honors = computed(() => homeInfo.value?.honorAptitude)

const companyCulture = computed(() => homeInfo.value?.companyStyle)

const videoResource = computed(() => {
	return homeInfo.value?.video?.[`video_${currentLang.value}`]
})

const getHomeInfo = async () => {
	const res = await axios.get(`/api/api//home/page`)
		.catch(err => {
			throw new Error(err.message)
		})
	console.log('res --------->', res)
	homeInfo.value = res.data
}

const getCustomerCase = async () => {
	const res = await axios.get('/api/api/strength?take=3')
		.catch(err => {
			throw new Error(err.message)
		})
	customerCase.value = res.data
	// currentItem.value = res.data[0]
	console.log('res --------->', res)
}

onMounted(() => {
	getHomeInfo()
	getCustomerCase()
})
</script>


<style lang="less" scoped>

</style>

